import styles from "./tab-title-with-error-count.less";

type TabTitleWithErrorCountProps = {
    tabName: string;
    errorCount: number;
};

export const TabTitleWithErrorCount = (props: TabTitleWithErrorCountProps) => {
    const { tabName, errorCount } = props;
    return (
        <div className={styles.tabTitleWithErrorCount}>
            <span>{tabName}</span>
            {errorCount > 0 ? <span className={styles.errorCount}>{errorCount}</span> : null}
        </div>
    );
};